import { JSX } from 'react'

import { For, VStack, Heading, Card, Stat } from '@chakra-ui/react'

import { Chart, useChart } from '@chakra-ui/charts'
import { Pie, PieChart, Area, AreaChart, Sector, Tooltip } from 'recharts'

import { LuGlobe } from 'react-icons/lu'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Office (): JSX.Element
{
	let options = useChart(
		{
			data: [
				{ name: '保安', value: 4, color: 'blue.solid' },
				{ name: '环卫', value: 3, color: 'orange.solid' },
				{ name: '电工', value: 1, color: 'pink.solid' },
				{ name: '其他', value: 2, color: 'green.solid' },

			],

		},

	)


	return (
		<Chart.Root boxSize="3xs" mt="4" mx="auto" chart={options}>
			<PieChart responsive>
				<Tooltip
					cursor={false}
					animationDuration={100}
					content={<Chart.Tooltip hideLabel />}
				/>

				<Pie
					innerRadius="70%"
					outerRadius="100%"
					startAngle={225}
					endAngle={-45}
					isAnimationActive={false}
					data={options.data}
					dataKey={options.key('value')}
					nameKey="name"
					shape={props => (
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
						<Sector {...props} fill={options.color(props.payload!.color)} />
					)}
				/>

			</PieChart>

		</Chart.Root>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Salary (): JSX.Element
{
	let options = useChart(
		{
			data: [
				{ value: 10 },
				{ value: 16 },
				{ value: 19 },
				{ value: 15 },
				{ value: 12 },
				{ value: 15 },

			],

			series: [{ color: 'teal.solid' }],

		},

	)

	return (
		<Card.Root w="xs" size="sm" variant="subtle" bg="white">
			<Card.Body>
				<Stat.Root>
					<Stat.Label>
						<LuGlobe />

						<span>合计</span>

					</Stat.Label>

					<Stat.ValueText>192.1k</Stat.ValueText>

				</Stat.Root>

			</Card.Body>

			<Chart.Root height="40" chart={options}>
				<AreaChart
					responsive
					data={options.data}
					margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
				>
					<For each={options.series}>
						{
							v => (
								<Area
									key={options.key(v.name)}
									isAnimationActive={false}
									dataKey={options.key(v.name)}
									// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
									fill={options.color(v.color)}
									fillOpacity={0.2}
									// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
									stroke={options.color(v.color)}
									strokeWidth={2}
								/>

							)

						}

					</For>

				</AreaChart>

			</Chart.Root>

		</Card.Root>

	)

}



export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	return (
		<VStack h="full" pt="4" justify="space-between">
			<Heading as="h3" size="lg">岗位分布</Heading>

			<Office />


			<Heading as="h3" size="lg" mt="auto">员工薪资分布</Heading>

			<Salary />


		</VStack>

	)

}
